export { default } from './Slide';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Slide/index.js
// module id = 323
// module chunks = 0